module.exports = __webpack_public_path__ + "0388afcc4f5c1cecd8f91408596cf7aa.MP3";